export default {"src":"/_next/static/media/bat-icon.2c6edf2b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};